import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Box, CircularProgress } from "@mui/material";
export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}><CircularProgress /></Box>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.householdId) return <Navigate to="/household" replace />;
  return <>{children}</>;
}
